import { getViewportStyleTriggers, loadDeferredComponentStyles } from '@theme/deferred-styles';

/** @type {Set<string>} */
const observedKeys = new Set();

function setupViewportStyleLoading() {
  const triggers = getViewportStyleTriggers();
  if (!triggers.length) return;

  if (!('IntersectionObserver' in window)) {
    for (const { key } of triggers) {
      loadDeferredComponentStyles(key).catch(() => {});
    }
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;

        const key = entry.target.getAttribute('data-deferred-viewport-styles');
        if (!key || observedKeys.has(key)) continue;

        observedKeys.add(key);
        loadDeferredComponentStyles(key).catch(() => {});
        observer.unobserve(entry.target);
      }
    },
    { rootMargin: '240px 0px', threshold: 0.01 }
  );

  for (const { key, selector } of triggers) {
    document.querySelectorAll(selector).forEach((element) => {
      if (!(element instanceof HTMLElement)) return;
      element.dataset.deferredViewportStyles = key;
      observer.observe(element);
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setupViewportStyleLoading, { once: true });
} else {
  setupViewportStyleLoading();
}
